import moment from 'moment';

export default function formatTime(time){
    return moment(time, ["h:mm A"]).format("HH:mm")
}